module.exports = __webpack_public_path__ + "img/badge_color_fia-application.2005d816.svg";